import Footer from "../Footer";
import Header from "../Header";
import React from "react";
import SetNoIndex from "../../lib/SetNoIndex";
import styles from "./ReferralErrorPage.module.css";
import {Column, Container, Row} from "../grid";

const strings = {
    description:
        "Thanks for your interest in Refer a Friend. Please refer to emails from 1st Financial Bank USA or call Customer Service at 1-800-733-1732 to access this program.",
    title: "Refer A Friend",
};

export default function ReferralErrorPage() {
    SetNoIndex();
    return (
        <>
            <Header />
            <Container className={styles.container}>
                <Row>
                    <Column>
                        <div className={styles.title}>{strings.title}</div>
                    </Column>
                </Row>
                <Row>
                    <Column>
                        <div className={styles.description}>{strings.description}</div>
                    </Column>
                </Row>
            </Container>
            <Footer />
        </>
    );
}
